<div class="text-center ma-font-setup" [ngClass]="{'row': isAcmic}">
  <div class="col" [ngClass]="{ 'margin-bottom mb24 .padding-left pl0': !isAcmic }">

    <h1 class="title-copy" [ngClass]="{'Col-363636':isAcmic}">{{ "CREATE_ACCOUNT" | translate }}</h1>
    <p [ngClass]="{ 'title-width': !isAcmic, 'acmic-title-width': isAcmic }">{{ "ENTER_YOUR_INFORMATION_AS_IT_APPEARS" | translate }}</p>
    <div class="row text-center margin-top" *ngIf="isAcmic" [ngClass]="{ 'mt16': !isAcmic, 'mt0 mb-4': isAcmic }">
      <div class="col">
        <app-find-policy-info-modal></app-find-policy-info-modal>       
      </div>
    </div>
  </div>
</div>
<mapfre-alert></mapfre-alert>
<app-create-account-form [inputs]="inputs"></app-create-account-form>
<div class="row text-center margin-top mt24" [ngClass]="{ 'signup-login-acmic': isAcmic }">
  <div class="col">
    <ng-container *ngIf="isAcmic else backButtonForMA">
    <mapfre-button
      additionalClasses="link-button red-link small no-border"
      [backIcon]="'./assets/img/icons/back-arrow-red.png'"
      [iconClasses]="'align-middle'"
      [routerLink]="['/login']"
      [showIconsCustom]="true"
    >
      {{ "LOGIN" | translate }}
    </mapfre-button>
  </ng-container>
  <ng-template #backButtonForMA>
    <mapfre-button
      (click)="goBack()"
      additionalClasses="link-button small-btn red-link no-margin button-border-red"
      [customIcon]="'assets/img/icons/back-arrow.png'"
      [backIcon]="'assets/img/icons/back-arrow-red.png'"
      [iconClasses]="'align-middle'"
      [showIconsCustom]="true"
    >  {{ 'BACK' | translate }}
    </mapfre-button>
  </ng-template>
  </div>
</div>
